import { type RefObject, useCallback, useLayoutEffect, useRef } from "react";

// A row appended out of sight is a row somebody has to go and find, so the click that adds one leaves the caret in it
// and the browser scrolls it into view for nothing. The ref goes on the box worth typing into rather than on the row:
// the first box a filter condition has already answers for itself, and the value beside it is the empty one.
export function useNewRowFocus(): { ref: RefObject<HTMLInputElement | null>; focusNewRow: () => void } {
  const ref = useRef<HTMLInputElement>(null);
  const wanted = useRef(false);

  // No dependencies, the render that draws the new row being the one this has to fire after; the flag is what keeps it
  // to that render rather than to a removal, a keystroke or the rows a link arrived with.
  useLayoutEffect(() => {
    if (!wanted.current) return;
    wanted.current = false;
    ref.current?.focus();
  });

  const focusNewRow = useCallback(() => {
    wanted.current = true;
  }, []);

  return { ref, focusNewRow };
}
